import { useMemo } from 'react';
import { useFeatureFlagEnabled } from 'posthog-js/react';
import { useSelector } from 'react-redux';
import type { ReduxState } from 'imddata';

const EMERGENCY_OVERRIDE: any = {
  'promo-subs': true,
  payg: true,
  'tiered-subs': true,
  'revenue-splits': true,
  'referral-system': true,
  'subs-v2': true,
  onboarding: true,
  'field-update-request-check-system': true,
};

export const useFeature = (featureKey: string) => {
  const devmode = useSelector((state: ReduxState) => state.dev.devmode);
  const devFeatures = useSelector((state: ReduxState) => state.dev.features);
  const dummyHook = useMemo(() => {
    if (devmode && devFeatures?.[featureKey] !== undefined) {
      return () => devFeatures[featureKey];
    }

    if (EMERGENCY_OVERRIDE[featureKey] !== undefined) {
      return () => EMERGENCY_OVERRIDE[featureKey];
    }

    return undefined;
  }, [devFeatures]);

  const featureHook = dummyHook || useFeatureFlagEnabled;

  return featureHook(featureKey);
};
